import React, { useEffect, useState, useMemo, useCallback } from "react";
import {
  MaterialReactTable,
  useMaterialReactTable,
} from "material-react-table";
import { useLocation, useNavigate } from "react-router-dom";
import api from "./Axios/api";
import Select from "react-select";
import Swal from "sweetalert2";
import BackBtn from "./common/BackBtn";
import { Discount } from "@mui/icons-material";
import { useSelector } from "react-redux";

const CreatePOForm = () => {
  // const user_branch = useSelector((state) => state.user.staff_FacLoc);
  const location = useLocation();
  const { ids } = location.state; // it use for create po details
  const { poId } = location.state; // it is use for edit po details

  const [data, setData] = useState([]);
  const [indent_fact, setIndent_fact] = useState(null);
  const [partyName,setPartyName]=useState(null);
  const [approve_Fact, setApprove_Fact] = useState(null);

  const itemId = Array.isArray(ids) ? ids : ids;

  const navigate = useNavigate();
  const [voucher, setVoucher] = useState([]);
  const [purchase_ledger, setPurchase_ledger] = useState([]);
  const [purchaseDataArr, setPurchaseDataArr] = useState([]);

  const [editingRowIndex, setEditingRowIndex] = useState(null);
  const [tempQuantity, setTempQuantity] = useState("");
  const [loadingRowIndex, setLoadingRowIndex] = useState(null);

  const [isVoucherExists, setIsVoucherExists] = useState(false);
  const [existingPoData, setExistingPoData] = useState(null);

  const handleDoubleClick = (rowIndex, value) => {
    setEditingRowIndex(rowIndex);
    setTempQuantity(value);
  };

  const handleQuantityChange = (value) => {
    setTempQuantity(value);
  };

  const handleSave = async (rowIndex, id) => {
    // console.log(rowIndex,"and",tempQuantity,"po",poId,"oyyo",id);return
    setLoadingRowIndex(rowIndex);
    try {
      await api.patch(`/purchase/edit-item-quantity/${id}`, {
        purchase_qty: tempQuantity,
      });
      setData((prevData) =>
        prevData.map((row, index) =>
          index === rowIndex ? { ...row, purchase_qty: tempQuantity } : row,
        ),
      );
      Swal.fire({
        icon: "success",
        title: "Updated!",
        text: "Quantity updated successfully.",
        timer: 1500,
      });
    } catch (error) {
      console.error("Error updating quantity:", error);
      Swal.fire({
        icon: "error",
        title: "Error!",
        text: "Failed to update quantity.",
      });
    }

    setLoadingRowIndex(null);
    setEditingRowIndex(null);
  };

  const [formState, setFormState] = useState({
    party_id: "",
    po_number: "",
    po_date: "",
    dispatch_through: "",
    destination: "",
    fright: ".",
    purchase_ledger: "BF Slag Purchase",
    purchase_ledger_name: "",
    terms_of_payment: "",
    voucher_type: "Select Voucher Type",
    voucher_type_name: "",
    delivery_terms: "",
  });

  const getEditData = async (id) => {
    try {
      const res = await api.get(
        `/purchase/get-approved-item-detail/?poId=${id}`,
      );
      setData(res.data.purchase);
      setIndent_fact(res.data.purchase[0].indent_factory_branch);
      setPartyName(res.data.purchase[0].party_name);
      setFormState({
        party_id: res.data.party_id,
        po_number: res.data.po_number,
        po_date: res.data.po_date.split("T")[0], // Extract date part only
        dispatch_through: res.data.dispatch_through,
        destination: res.data.destination,
        fright: res.data.fright,
        purchase_ledger: res.data.purchase_ledger,
        purchase_ledger_name: res.data.purchase_ledger_name,
        terms_of_payment: res.data.terms_of_payment,
        voucher_type: res.data.voucher_type,
        voucher_type_name: res.data.voucher_type_name,
        delivery_terms: res.data.delivery_terms,
      });
    } catch (error) {
      console.log(error);
    }
  };

  const getApproveData = async (itemId) => {
    try {
      const res = await api.get(`/purchase/get-approved-item-detail/${itemId}`);
      setData(res.data);
      setApprove_Fact(res.data[0].indent_factory_branch);
    } catch (error) {
      console.log(error);
    }
  };
  useEffect(() => {
    getApproveData();
  }, []);

  const getVoucher = async () => {
    try {
      const res = await api.get(`/voucher-type/get`);
      const data = res.data;
      let filteredData;
      if (indent_fact) {
        filteredData = data.filter(
          (item) => item.voucher_factory === indent_fact,
        );
      } else if (approve_Fact) {
        filteredData = data.filter(
          (item) => item.voucher_factory === approve_Fact,
        );
      }
      const newData = filteredData.map((item) => ({
        label: item.voucher_type,
        value: item._id,
      }));

      setVoucher(newData);
    } catch (error) {
      console.error("Error while fetching vouchers:", error);
    }
  };

  const getpurchase_ledger = async () => {
    try {
      const res = await api.get(`/purchase-ledger/get-all`);
      const data = res.data;

      let filteredData = data;
      if (indent_fact) {
        filteredData = data.purchaseLedger.filter(
          (item) => item.purchase_ledger_factory === indent_fact,
        );
      } else if (approve_Fact) {
        filteredData = data.purchaseLedger.filter(
          (item) => item.purchase_ledger_factory === approve_Fact,
        );
      }
      const newData = filteredData.map((item) => ({
        label: item.purchase_ledger_name,
        value: item._id,
      }));
      setPurchase_ledger(newData);
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    const newData = data.map((data, index) => ({
      purchase_id: data._id,
      stock_desc: data.stock_desc,
    }));
    setPurchaseDataArr(newData);
    setFormState((prev) => ({ ...prev, party_id: data[0]?.party }));
  }, [data]);

  useEffect(() => {
    if (indent_fact) {
      getpurchase_ledger();
      getVoucher();
    }
  }, [indent_fact]);

  useEffect(() => {
    if (approve_Fact) {
      getpurchase_ledger();
      getVoucher();
    }
  }, [approve_Fact]);

  useEffect(() => {
    ids && getApproveData(ids.join(","));
    poId && getEditData(poId);
  }, [ids, poId]);

  const handleChange = async (e) => {
    const { name, value } = e.target;
    setFormState({
      ...formState,
      [name]: value,
    });

    if (name === "po_number") {
      try {
        const response = await api.get(
          `/po-detail/check-existing-po-no?po_number=${value}`,
        );
        if (response.data.success) {
          const data = response.data.data;
          setExistingPoData(data);
          setIsVoucherExists(true);
        } else {
          setIsVoucherExists(false);
          setExistingPoData(null);
        }
      } catch (err) {
        console.error("Error checking voucher number:", err);
        setExistingPoData(null);
        setIsVoucherExists(false);
      }
    }
  };

  const validateForm = () => {
    const {
      po_number,
      po_date,
      dispatch_through,
      destination,
      purchase_ledger,
      terms_of_payment,
      voucher_type,
      delivery_terms,
    } = formState;
    if (
      !po_number ||
      !po_date ||
      !dispatch_through ||
      !destination ||
      !purchase_ledger ||
      !terms_of_payment ||
      !voucher_type ||
      !delivery_terms
    ) {
      Swal.fire({
        icon: "error",
        title: "Validation Error",
        text: "Please fill all the required fields marked with *",
      });
      return false;
    }
    return true;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!isVoucherExists && !validateForm()) return;

    try {
      let res;
      if (poId) {
        if (isVoucherExists) {
          try {
            await Promise.all(
              data.map(async (item) => {
                await api.patch("/purchase/use-existing-po", {
                  po_id: existingPoData._id,
                  purchase_id: item._id,
                });
              }),
            );

            await api.delete(`/po-detail/delete/${poId}`);

            Swal.fire({
              icon: "info",
              title: "PO Updated",
              text: "Existing voucher matched. Items moved to existing PO.",
              timer: 2000,
            });
            return;
          } catch (error) {
            console.error("Failed to edit PO:", error);
            Swal.fire({
              icon: "error",
              title: "Error",
              text: "Failed to update using existing PO.",
            });
            return;
          }
        } else {
          res = await api.patch(`/po-detail/update/${poId}`, {
            purchaseDataArr,
            ...formState,
          });
        }
      } else {
        if (isVoucherExists) {
          try {
            await Promise.all(
              data.map(async (item) => {
                await api.patch("/purchase/use-existing-po", {
                  po_id: existingPoData._id,
                  purchase_id: item._id,
                });
              }),
            );

            Swal.fire({
              icon: "info",
              title: "PO Already Exists",
              text: "The existing purchase order has been reused successfully.",
              timer: 2000,
            });

            return;
          } catch (error) {
            console.error("Failed to use existing PO:", error);
            Swal.fire({
              icon: "error",
              title: "Error",
              text: "Failed to reuse the existing purchase order.",
            });
            return;
          }
        } else {
          res = await api.post(`/po-detail/add`, {
            purchaseDataArr,
            ...formState,
          });
        }
      }
      Swal.fire({
        icon: "success",
        title: "Success",
        text: "Purchase order created successfully",
        timer: 1500,
      });
      navigate("/created-po-list");
    } catch (error) {
      Swal.fire({
        icon: "error",
        title: "Error",
        text: "An error occurred while creating the purchase order",
      });
    }
  };

  const handleReset = () => {
    setIndent_fact(null);
    setFormState({
      po_number: "",
      po_date: "",
      dispatch_through: "",
      destination: "",
      fright: ".",
      purchase_ledger: "BF Slag Purchase",
      terms_of_payment: "",
      voucher_type: "Select Voucher Type",
      delivery_terms: "",
    });
    setIsVoucherExists(false);
    setExistingPoData(null);
  };

  const handleStockDescChange = useCallback((rowIndex, value) => {
    setData((prevData) =>
      prevData.map((row, index) =>
        index === rowIndex ? { ...row, stock_desc: value } : row,
      ),
    );
  }, []);

  const handleKeyDown = useCallback(
    (e, type, rowIndex) => {
      if (e.key == "Enter") {
        const updateValue = `${e.target.value};`;
        if (type == "stock") {
          handleStockDescChange(rowIndex, updateValue);
        } else if ((type = "delivery")) {
          setFormState((prev) => ({ ...prev, delivery_terms: updateValue }));
        }
      }
    },
    [handleStockDescChange],
  );

  const columns = useMemo(
    () => [
      {
        accessorKey: "item_title",
        header: "ITEM NAME",
        size: 100,
      },
      {
        accessorKey: "purchase_qty",
        header: "QUANTITY",
        size: 50,
        Cell: ({ row }) => {
          const isEditing = row.index === editingRowIndex;
          const isLoading = row.index === loadingRowIndex;
          return isEditing ? (
            <div className="flex items-center gap-2">
              <input
                type="number"
                value={tempQuantity}
                onChange={(e) => handleQuantityChange(e.target.value)}
                className="w-16 border border-gray-300 p-1 text-center"
                autoFocus
              />
              <button
                onClick={() => handleSave(row.index, row.original._id)}
                className={`px-2 py-1 rounded ${
                  isLoading ? "bg-gray-400" : "bg-green-500 text-white"
                }`}
                disabled={isLoading} // Disable button while loading
              >
                {isLoading ? "Saving..." : "Done"}
              </button>
            </div>
          ) : (
            <div
              onDoubleClick={() =>
                handleDoubleClick(row.index, row.original.purchase_qty)
              }
              className="cursor-pointer"
            >
              {row.original.purchase_qty}
            </div>
          );
        },
      },
      {
        accessorKey: "rate",
        header: "Rate",
        size: 20,
      },
      {
        accessorKey: "item_unit",
        header: "Unit",
        size: 20,
      },
      {
        accessorKey: "discount",
        header: "Dis (%)",
        size: 20,
      },
      {
        accessorKey: "total_without_gst",
        header: "Total (Without Gst)",
        Cell: ({ cell }) => `₹${Number(cell.getValue()).toFixed(2)}`,
        size: 70,
        Footer: () => (
          <strong className="font-bold text-lg text-purple-500">
            Total = ₹
            {data
              .reduce((sum, row) => sum + Number(row.total_without_gst || 0), 0)
              .toFixed(2)}
          </strong>
        ),
      },
      {
        accessorKey: "item_gst",
        header: "GST (%)",
        size: 30,
      },
      {
        accessorKey: "total_with_gst",
        header: "Total (With Gst)",
        Cell: ({ cell }) => `₹${Number(cell.getValue()).toFixed(2)}`,
        size: 50,
        Footer: () => (
          <strong className="font-bold text-lg text-green-500">
            Total = {data.reduce((sum, row) => sum + Number(row.total_with_gst || 0), 0).toFixed(2)}
          </strong>
        ),
      },
      {
        accessorKey: "stock_desc",
        header: "Stock Description",
        size: 100,
        Cell: ({ row, cell }) => (
          <textarea
            type="text"
            value={cell.getValue() || ""}
            onChange={(e) => handleStockDescChange(row.index, e.target.value)}
            onKeyDown={(e) => handleKeyDown(e, "stock", row.index)}
            className="block w-full rounded border-0 py-1.5 pl-2 pr-2 text-gray-900 ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6"
          />
        ),
      },
    ],
    [handleStockDescChange, data, editingRowIndex, tempQuantity],
  );
  const Factory = {
  "666c0f5ebeca5ab2c65b2c85": "Polybond Insulation",
  "666c0f5ebeca5ab2c65b2c86": "Polybond Project",
  "666c0f5ebeca5ab2c65b2c87": "Polybond RockFibre",
};
  const returnHandler = async (ids) => {
    try {
      const joinId = ids.join(",");
      // console.log(joinId)
      const res = await api.patch(`/purchase/return-item/${joinId}`);
      // console.log("return-item-detail", res.data);
      navigate(`/returnList`);
    } catch (error) {
      console.log(error);
    }
  };
  const table = useMaterialReactTable({
    columns,
    data,
    enableRowSelection: true,
    renderToolbarAlertBannerContent: (tableInstance) => {
      const selectedRowIds = Object.keys(
        tableInstance.table.getState().rowSelection,
      );
      const selectedRows = selectedRowIds.map(
        (id) => tableInstance.table.getRow(id).original,
      );
      const ids = selectedRows.map((item) => item.indent_item_id);
      return (
        <div className="flex items-center gap-3">
          {tableInstance.selectedAlert}
          <div
            className="text-sm text-[#36C2CE] cursor-pointer"
            onClick={(e) => {
              returnHandler(ids);
            }}
          >
            Return
          </div>
        </div>
      );
    },
  });

  return (
    <div className="flex-1 px-5 w-full justify-center items-center">
      <div className="h-10 px-2 flex justify-between items-center text-violet-500 font-bold rounded-md bg-[#fdfdfd] shadow my-2">
        <div className="text-lg">Create PO Form</div>
        <BackBtn />
            </div>
            {partyName && (
        <div className="h-10 px-2 flex justify-center items-center font-bold rounded-md bg-[#fdfdfd] shadow my-2">
          {partyName}
          {Factory[indent_fact]?.trim() && (
            <>
              {" ("}
              <span className="text-red-600 inline">
                {Factory[indent_fact]}
              </span>
              {")"}
            </>
          )}
        </div>
      )}
      <div className="w-full min-h-[500px] rounded-md shadow">
        <MaterialReactTable table={table} />

        <div className="bg-[#fdfdfd] border mt-2 p-2 flex w-full justify-between items-center rounded-md shadow">
          <div className="p-4 flex rounded-md items-center w-full min-h-16">
            <div className="w-full">
              <form onSubmit={handleSubmit}>
                <div className="grid grid-cols-1 md:grid-cols-3 gap-6 w-full">
                  <div className="flex flex-col">
                    <label className="mb-2 font-semibold text-gray-700">
                      Voucher Number <span className="text-red-500">*</span>
                    </label>
                    <input
                      type="text"
                      name="po_number"
                      value={formState.po_number}
                      onChange={(e) => {
                        handleChange(e);
                        setIsVoucherExists(false);
                      }}
                      className="block w-full rounded border-0 py-1.5 pl-7 pr-10 text-gray-900 ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6"
                      placeholder="Enter Vch no."
                    />
                  </div>
                  <div className="flex flex-col">
                    <label className="mb-2 font-semibold text-gray-700">
                      Voucher Date <span className="text-red-500">*</span>
                    </label>
                    <input
                      type="date"
                      name="po_date"
                      value={
                        isVoucherExists
                          ? existingPoData?.po_date?.split("T")[0]
                          : formState.po_date
                      }
                      onChange={handleChange}
                      disabled={isVoucherExists && ids}
                      className="block w-full rounded border-0 py-1.5 pl-7 pr-10 text-gray-900 ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6"
                    />
                  </div>
                  <div className="flex flex-col">
                    <label className="mb-2 font-semibold text-gray-700">
                      Dispatch Through <span className="text-red-500">*</span>
                    </label>
                    <input
                      type="text"
                      name="dispatch_through"
                      value={
                        isVoucherExists
                          ? existingPoData?.dispatch_through
                          : formState.dispatch_through
                      }
                      onChange={handleChange}
                      disabled={isVoucherExists && ids}
                      className="block w-full rounded border-0 py-1.5 pl-7 pr-10 text-gray-900 ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6"
                      placeholder="Enter dispatch details"
                    />
                  </div>
                  <div className="flex flex-col">
                    <label className="mb-2 font-semibold text-gray-700">
                      Destination <span className="text-red-500">*</span>
                    </label>
                    <input
                      type="text"
                      name="destination"
                      value={
                        isVoucherExists
                          ? existingPoData?.destination
                          : formState.destination
                      }
                      onChange={handleChange}
                      disabled={isVoucherExists && ids}
                      className="block w-full rounded border-0 py-1.5 pl-7 pr-10 text-gray-900 ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6"
                      placeholder="Enter destination"
                    />
                  </div>
                  <div className="flex flex-col">
                    <label className="mb-2 font-semibold text-gray-700">
                      Other reference
                    </label>
                    <input
                      type="text"
                      name="fright"
                      value={formState.fright}
                      onChange={handleChange}
                      disabled={isVoucherExists && ids}
                      className="block w-full rounded border-0 py-1.5 pl-7 pr-10 text-gray-900 ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6"
                      placeholder="Enter fright"
                    />
                  </div>
                  <div className="flex flex-col">
                    <label className="mb-2 font-semibold text-gray-700">
                      Purchase Ledger <span className="text-red-500">*</span>
                    </label>

                    <Select
                      name="purchase_ledger"
                      options={purchase_ledger}
                      isDisabled={isVoucherExists && ids}
                      placeholder={
                        formState.purchase_ledger_name || "please select..."
                      }
                      // value={formState.purchase_ledger_name}
                      value={purchase_ledger.find(
                        (option) => option.value === formState.purchase_ledger,
                      )}
                      onChange={(selectedOption) => {
                        // console.log("Selected Data:", selectedOption);
                        setFormState({
                          ...formState,
                          purchase_ledger: selectedOption.value,
                          purchase_ledger_name: selectedOption.label,
                        });
                      }}
                      className="block w-full rounded border-0 py-1.5 pl-7 pr-10 text-gray-900 ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6"
                    />
                  </div>

                  <div className="flex flex-col">
                    <label className="mb-2 font-semibold text-gray-700">
                      Terms of Payment <span className="text-red-500">*</span>
                    </label>
                    <input
                      type="text"
                      name="terms_of_payment"
                      value={
                        isVoucherExists
                          ? existingPoData?.terms_of_payment
                          : formState.terms_of_payment
                      }
                      onChange={handleChange}
                      disabled={isVoucherExists && ids}
                      className="block w-full rounded border-0 py-1.5 pl-7 pr-10 text-gray-900 ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6"
                      placeholder="Enter terms of payment"
                    />
                  </div>
                  <div className="flex flex-col">
                    <label className="mb-2 font-semibold text-gray-700">
                      Voucher Type <span className="text-red-500">*</span>
                    </label>
                    <Select
                      name="voucher_type"
                      options={voucher}
                      isDisabled={isVoucherExists && ids}
                      placeholder={
                        formState.voucher_type_name || "Please select...."
                      }
                      value={formState.voucher_type_name}
                      onChange={(selectedOption) =>
                        setFormState({
                          ...formState,
                          voucher_type: selectedOption.value,
                          voucher_type_name: selectedOption.label,
                        })
                      }
                      className="block w-full rounded border-0 py-1.5 pl-7 pr-10 text-gray-900 ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6"
                    />
                  </div>
                  <div className="flex flex-col">
                    <label className="mb-2 font-semibold text-gray-700">
                      Delivery Terms <span className="text-red-500">*</span>
                    </label>
                    <textarea
                      type="text"
                      name="delivery_terms"
                      value={
                        isVoucherExists
                          ? existingPoData?.delivery_terms
                          : formState.delivery_terms
                      }
                      onKeyDown={(e) => {
                        handleKeyDown(e, "delivery");
                      }}
                      onChange={handleChange}
                      disabled={isVoucherExists && ids}
                      className="block w-full rounded border-0 py-1.5 pl-7 pr-10 text-gray-900 ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6"
                      placeholder="Enter delivery terms"
                    />
                  </div>
                </div>
                <div className="flex items-center justify-end space-x-4 mt-4">
                  <button
                    type="button"
                    onClick={handleReset}
                    className="bg-gray-400 hover:bg-gray-500 text-white font-bold py-2 px-4 rounded"
                  >
                    Reset
                  </button>
                  <button
                    type="submit"
                    className="bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded"
                  >
                    Submit
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CreatePOForm;
